import { useLang } from "@/contexts/LanguageContext";
import { ShieldCheck, Award, Globe, BadgeCheck } from "lucide-react";

/**
 * Trust bar — Atlas Snow section.
 * Ultra-thin dividers, typographic restraint, no gradients.
 */
const TrustBar = () => {
  const { t } = useLang();

  const badges = [
    { icon: ShieldCheck, label: "IRCC compliant", sub: "Conforme IRCC" },
    { icon: Award, label: "RCIC licensed", sub: "Consultants agréés" },
    { icon: Globe, label: "Bilingual FR · EN · AR", sub: "Trilingue" },
    { icon: BadgeCheck, label: "500+ files completed", sub: "Dossiers traités" },
  ];

  return (
    <section
      data-testid="trust-bar"
      className="relative bg-[#F5F2EE] text-[#0D1117] py-12 sm:py-16 border-y border-[#0D1117]/8"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-center justify-center gap-y-8">
          {badges.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                data-testid={`trust-badge-${i}`}
                className="flex items-center gap-4 px-6 sm:px-9 border-r border-[#0D1117]/10 last:border-r-0"
              >
                <Icon className="w-5 h-5 text-[#E8A045]" strokeWidth={1.3} />
                <div>
                  <div className="font-mono-accent text-[10px] text-[#0D1117]">
                    {b.label}
                  </div>
                  <div className="font-display italic text-sm text-[#0D1117]/55 mt-0.5">
                    {b.sub}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Subtle context line */}
        <div className="mt-8 text-center font-mono-accent text-[9px] text-[#0D1117]/40">
          {t.trust.a} &nbsp;·&nbsp; {t.trust.b} &nbsp;·&nbsp; {t.trust.c}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
